import { useCallback } from 'react';

import { usePersistentState } from '@cast/utils';

import {
  ONE_CLICK_PROMOTION_BANNER_DISMISSED_KEY,
  ONE_CLICK_PROMOTION_DIALOG_SEEN_KEY,
} from './_constants';

export const useRedesignAnnouncementState = () => {
  const [bannerDismissed, setBannerDismissed] = usePersistentState(
    ONE_CLICK_PROMOTION_BANNER_DISMISSED_KEY,
    false
  );
  const [dialogSeen, setDialogSeen] = usePersistentState(
    ONE_CLICK_PROMOTION_DIALOG_SEEN_KEY,
    false
  );

  const dismissBanner = useCallback(
    () => setBannerDismissed(true),
    [setBannerDismissed]
  );
  const markDialogSeen = useCallback(
    () => setDialogSeen(true),
    [setDialogSeen]
  );

  return { bannerDismissed, dismissBanner, dialogSeen, markDialogSeen };
};
